
import { QuizQuestion } from "@/types";

export const quizQuestions: QuizQuestion[] = [
  {
    id: 1,
    text: "Does your board have a designated AI oversight committee or individual?",
    options: [
      { id: "1-1", text: "Yes", score: 2 },
      { id: "1-2", text: "In planning", score: 1 },
      { id: "1-3", text: "No / Not sure", score: 0 },
    ],
  },
  {
    id: 2,
    text: "How frequently does your board review AI-related risks?",
    options: [
      { id: "2-1", text: "Every meeting", score: 2 },
      { id: "2-2", text: "Quarterly", score: 1 },
      { id: "2-3", text: "Annually", score: 0.5 },
      { id: "2-4", text: "Never", score: 0 },
    ],
  },
  {
    id: 3,
    text: "Does your board receive regular updates on emerging AI regulations?",
    options: [
      { id: "3-1", text: "Yes, routinely", score: 2 },
      { id: "3-2", text: "Occasionally", score: 1 },
      { id: "3-3", text: "Only when major changes occur", score: 0.5 },
      { id: "3-4", text: "Not at all", score: 0 },
    ],
  },
  {
    id: 4,
    text: "Does your board have access to external expertise on AI governance?",
    options: [
      { id: "4-1", text: "Yes", score: 2 },
      { id: "4-2", text: "Partially", score: 1 },
      { id: "4-3", text: "No", score: 0 },
    ],
  },
  {
    id: 5,
    text: "Are there documented AI governance policies in place at your organization?",
    options: [
      { id: "5-1", text: "Yes", score: 2 },
      { id: "5-2", text: "In development", score: 1 },
      { id: "5-3", text: "No / Not sure", score: 0 },
    ],
  },
  {
    id: 6,
    text: "Does your board include members with experience in technology or AI?",
    options: [
      { id: "6-1", text: "Yes", score: 2 },
      { id: "6-2", text: "Partially", score: 1 },
      { id: "6-3", text: "No", score: 0 },
    ],
  },
  {
    id: 7,
    text: "How does your board evaluate the ethical implications of AI projects?",
    options: [
      { id: "7-1", text: "Through a formal review process", score: 2 },
      { id: "7-2", text: "Through informal discussions", score: 1 },
      { id: "7-3", text: "No established process", score: 0 },
      { id: "7-4", text: "Not sure", score: 0 },
    ],
  },
  {
    id: 8,
    text: "Is there a system for regular monitoring and reporting of AI risks?",
    options: [
      { id: "8-1", text: "Yes", score: 2 },
      { id: "8-2", text: "In planning", score: 1 },
      { id: "8-3", text: "No", score: 0 },
    ],
  },
  {
    id: 9,
    text: "How confident is your board in overseeing AI initiatives?",
    options: [
      { id: "9-1", text: "Very confident", score: 2 },
      { id: "9-2", text: "Somewhat confident", score: 1 },
      { id: "9-3", text: "Not confident / Unsure", score: 0 },
    ],
  },
  {
    id: 10,
    text: "Does your board review third-party AI vendor due diligence reports?",
    options: [
      { id: "10-1", text: "Yes", score: 2 },
      { id: "10-2", text: "Sometimes", score: 1 },
      { id: "10-3", text: "No / Not applicable", score: 0 },
    ],
  },
];
